<div data-test="wScsUpMn" class="page-wrap">
  <div data-test="Anw5Bm6m" class="modal modal_fullscreen active">
    <div data-test="iLVy1yzc" class="modal__wrap" data-simplebar>
      <div data-test="zpilGRnJ" class="modal__window">
        <button
          data-test="8wViv4jI"
          class="modal__close"
          data-dismiss="modal"
          type="button"
          (click)="close()"
        >
          <span data-test="0Jg1ePg9" class="badge badge_gray">
            <i data-test="60kHOyd7" class="material-icons md-12">close</i>
          </span>
        </button>
        <div data-test="zEM4HNzK" class="container-fluid">
          <div data-test="dTZ7gTcL" class="modal__header">
            <h2 data-test="aai505y7" class="modal__title">Choose a module</h2>
          </div>
          <div data-test="OdU5rPyq" class="cards">
            <div data-test="xqwCNeCK" class="cards__wrap row">
              <div data-test="y1wuB1Za" class="cards__item col-auto">
                <a
                  data-test="NNMFP1Nh"
                  class="card card_shift"
                  routerLink="/company-management"
                  (click)="navigate('/company-management')"
                  #rlaCompanyManagement="routerLinkActive"
                  routerLinkActive="active"
                >
                  <div data-test="d5JGb-i3" class="card__wrap">
                    <div data-test="Cb2J8b1H" class="card__img">
                      <svg
                        data-test="pjCfnB2E"
                        class="icon__icon-company-big"
                        width="66px"
                        height="58px"
                      >
                        <use xlink:href="#icon-company-big"></use>
                      </svg>
                    </div>
                    <h3 data-test="C43-zSMn" class="card__title">Company Management</h3>
                    <div data-test="baulxezJ" class="card__text">
                      A small description of the module, for which it is needed.
                    </div>
                    <div data-test="-QRUCeko" class="card__hover">
                      <div
                        data-test="lhkq59n9"
                        class="card__icon"
                        *ngIf="!rlaCompanyManagement.isActive"
                      >
                        <i data-test="_Y7hXlFo" class="material-icons">arrow_forward</i>
                      </div>
                      <div
                        data-test="JNUaXFHr"
                        class="card__icon"
                        *ngIf="rlaCompanyManagement.isActive"
                      >
                        <i data-test="mO9PM68f" class="material-icons">check</i>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div
                *ngIf="userPermissions.INTERFACE_HR"
                data-test="Z4YPLRuR"
                class="cards__item col-auto"
              >
                <a
                  data-test="FEbG8jNm"
                  class="card card_shift"
                  (click)="navigate('/human-resources/internal/active')"
                  routerLink="/human-resources/internal/active"
                  #rlaHumanResources="routerLinkActive"
                  routerLinkActive="active"
                >
                  <div data-test="4VYqytV1" class="card__wrap">
                    <div data-test="Xv1A1WSW" class="card__img">
                      <svg
                        data-test="kipazqKA"
                        class="icon__icon-hr-big"
                        width="57px"
                        height="57.99px"
                      >
                        <use xlink:href="#icon-hr-big"></use>
                      </svg>
                      <!--<span class="card__notification-badge badge badge_notification">5</span>-->
                    </div>
                    <h3 data-test="69GC--K3" class="card__title">Human Resources</h3>
                    <div data-test="07_fTUGt" class="card__text">
                      A small description of the module, for which it is needed.
                    </div>
                    <div data-test="a4RXXY6r" class="card__hover">
                      <div
                        data-test="6CvwZb-8"
                        class="card__icon"
                        *ngIf="!rlaHumanResources.isActive"
                      >
                        <i data-test="6jmmooT9" class="material-icons">arrow_forward</i>
                      </div>
                      <div
                        data-test="XClSZt25"
                        class="card__icon"
                        *ngIf="rlaHumanResources.isActive"
                      >
                        <i data-test="yfD5KIB9" class="material-icons">check</i>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <!-- <div class="cards__item col-auto">
                <a class="card card_shift">
                  <div class="card__wrap">
                    <div class="card__img">
                      <svg class="icon__icon-booking" width="66px" height="58px">
                        <use xlink:href="#icon-booking"></use>
                      </svg>
                    </div>
                    <h3 class="card__title">Sales / Booking</h3>
                    <div class="card__text">A small description of the module, for which it is needed.</div>
                    <div class="card__hover">
                      <div class="card__icon"><i class="material-icons">arrow_forward</i> </div>
                    </div>
                  </div>
                </a>
              </div>
              <div class="cards__item col-auto">
                <a class="card card_shift">
                  <div class="card__wrap">
                    <div class="card__img">
                      <svg class="icon__icon-public-zone" width="64px" height="58px">
                        <use xlink:href="#icon-public-zone"></use>
                      </svg>
                    </div>
                    <h3 class="card__title">Public Zone Management</h3>
                    <div class="card__text">A small description of the module, for which it is needed.</div>
                    <div class="card__hover">
                      <div class="card__icon"><i class="material-icons">arrow_forward</i> </div>
                    </div>
                  </div>
                </a>
              </div>
              <div class="cards__item col-auto">
                <a class="card card_shift card_upgrade">
                  <div class="card__wrap">
                    <div class="card__img">
                      <svg class="icon__icon-finance-2" width="47px" height="58px">
                        <use xlink:href="#icon-finance-2"></use>
                      </svg>
                    </div>
                    <h3 class="card__title">Finance</h3>
                    <div class="card__text">A small description of the module, for which it is needed.</div>
                    <div class="card__hover">
                      <button class="card__button button_sm button button_primary w-100">Upgrade account</button>
                    </div>
                  </div>
                </a>
              </div>
              <div class="cards__item col-auto">
                <a class="card card_shift card_upgrade">
                  <div class="card__wrap">
                    <div class="card__img">
                      <svg class="icon__icon-reporting-2" width="54.03px" height="58px">
                        <use xlink:href="#icon-reporting-2"></use>
                      </svg>
                    </div>
                    <h3 class="card__title">Reports</h3>
                    <div class="card__text">A small description of the module, for which it is needed.</div>
                    <div class="card__hover">
                      <button class="card__button button_sm button button_primary w-100">Upgrade account</button>
                    </div>
                  </div>
                </a>
              </div> -->
              <div
                *ngIf="userPermissions.INTERFACE_TIME_TRACKING"
                data-test="ag6iuMU5"
                class="cards__item col-auto"
              >
                <a
                  data-test="MzthDODt"
                  class="card card_shift"
                  routerLink="/time-tracking"
                  (click)="navigate('/time-tracking')"
                  #rlaTimeTracking="routerLinkActive"
                  routerLinkActive="active"
                >
                  <div data-test="9ZG1YTRI" class="card__wrap">
                    <div data-test="tn0BzGfu" class="card__img">
                      <svg
                        data-test="djdqxK87"
                        class="icon__icon-timetracking"
                        width="90px"
                        height="58px"
                      >
                        <use xlink:href="#icon-timetracking"></use>
                      </svg>
                    </div>
                    <!-- <h3 class="card__title">Time Tracking & Boards</h3> -->
                    <h3 data-test="KVJ4EiKd" class="card__title">Time Tracking</h3>
                    <div data-test="7SfGorw7" class="card__text">
                      A small description of the module, for which it is needed.
                    </div>
                    <div data-test="FnCMhNVC" class="card__hover">
                      <div
                        data-test="FLbwIQGR"
                        class="card__icon"
                        *ngIf="!rlaTimeTracking.isActive"
                      >
                        <i data-test="rtvlGofj" class="material-icons">arrow_forward</i>
                      </div>
                      <div
                        data-test="n5U2wN7Z"
                        class="card__icon"
                        *ngIf="rlaTimeTracking.isActive"
                      >
                        <i data-test="DOGWBatA" class="material-icons">check</i>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <!-- <div class="cards__item col-auto">
                <a class="card card_shift">
                  <div class="card__wrap">
                    <div class="card__img">
                      <svg class="icon__icon-wm" width="88px" height="58.13px">
                        <use xlink:href="#icon-wm"></use>
                      </svg>
                    </div>
                    <h3 class="card__title">Warehouse Management</h3>
                    <div class="card__text">A small description of the module, for which it is needed.</div>
                    <div class="card__hover">
                      <div class="card__icon"><i class="material-icons">arrow_forward</i> </div>
                    </div>
                  </div>
                </a>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
